import { twMerge } from 'tailwind-merge';
import MuiButton from '@mui/material/Button';

import { ButtonProps } from './types';
import { colorClassname, variantClassname } from './styles';

export const Button = ({
  className,
  color = 'primary',
  variant = 'contained',
  ...props
}: ButtonProps) => {
  const baseClasses = variantClassname[variant];
  const colorClasses = colorClassname[color]?.[variant];

  return (
    <MuiButton
      disableRipple={variant === 'text'}
      className={twMerge(
        `h-10 rounded-3xl p-2.5 text-sm leading-[var(--body-line)] font-medium normal-case`,
        baseClasses,
        colorClasses,
        className
      )}
      {...props}
    />
  );
};

export type { ButtonProps };
